const STORAGE_KEY = 'oauth_request';
const MAX_AGE_MS = 10 * 60 * 1000;

export const oauthScopeLabels = {
  consultar: 'Consultar vendas e notas',
  emitir: 'Emitir notas',
  cancelar: 'Cancelar notas'
};

export const clearOAuthRequest = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    return;
  }
};

export const getOAuthRequest = () => {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY);
    const stored = value ? JSON.parse(value) : null;

    if (!stored) {
      return null;
    }

    const isRecent =
      typeof stored.savedAt === 'number' &&
      Date.now() - stored.savedAt <= MAX_AGE_MS;

    if (!isRecent || !stored.request) {
      clearOAuthRequest();
      return null;
    }

    return stored.request;
  } catch (e) {
    clearOAuthRequest();
    return null;
  }
};

export const saveOAuthRequest = (request) => {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ request, savedAt: Date.now() })
    );
  } catch (e) {
    return;
  }
};

const useOAuthRequest = () => ({
  get: getOAuthRequest,
  save: saveOAuthRequest,
  clear: clearOAuthRequest
});

export default useOAuthRequest;
